import React, { memo } from 'react';
import { INSURANCE_TYPE } from '../../../utils/insuranceTypeUtils';
import openIcon from '../../../assets/img/open-icon.svg';

/**
 * 検索結果テーブルの1行コンポーネント
 *
 * DocumentCatalogItem の各フィールドを表のセルとして表示する。
 * product_type / detail_info / enrollment_start / enrollment_end が null の場合は「—」を表示する。
 * 詳細ボタン押下時に onNavigate コールバックを呼び出し、
 * オーケストレーターフック側で document_type_code による遷移先の分岐処理が行われる。
 *
 * @param {Object} props
 * @param {Object} props.item - DocumentCatalogItem（APIレスポンスの items 要素）
 * @param {Function} props.onNavigate - 詳細遷移コールバック（引数: DocumentCatalogItem）
 */
const formatDate = (val) => (val ? val.slice(0, 10).replace(/-/g, '/') : '—');

const ResultTableRow = ({ item, onNavigate }) => {
  const insuranceTypeLabel =
    item.insurance_type_id === INSURANCE_TYPE.LIFE ? '生保' : '損保';

  return (
    <tr>
      <td className="dc-th--no">{item.no}</td>
      <td className="dc-th--type">{insuranceTypeLabel}</td>
      <td className="dc-th--doc-type">{item.document_type_name}</td>
      <td className="dc-th--min">{item.insurance_company_name}</td>
      <td className="dc-th--wide">{item.category || '—'}</td>
      <td className="dc-th--wide">{item.document_name}</td>
      <td className="dc-th--wide">{item.remarks || '—'}</td>
      <td className="dc-th--wide">{item.additional_info || '—'}</td>
      <td className="dc-th--date">{formatDate(item.date_from)}</td>
      <td className="dc-th--action">
        <div className="view-files-container">
          <img
            src={openIcon}
            alt="詳細を見る"
            className="view-files-icon"
            onClick={() => onNavigate(item)}
          />
        </div>
      </td>
    </tr>
  );
};

export default memo(ResultTableRow);
